import React from 'react';
import { motion } from 'framer-motion';
import { steps } from '../data/faqs';
export function Steps() {
  return <section aria-label="Nasıl çalışır" className="bg-warm" data-id="element-248" data-mp="18d1ranxk8i7w">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "12px",
      paddingBottom: "22px"
    }} data-id="element-249" data-mp="umyawdld3iqd">
        <div className="text-center" data-id="element-250" data-mp="yns1xfu3pdnh">
          <h2 className="mx-auto max-w-3xl font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-251" data-mp="ymqjureo3qw9">
            Bugünden itibaren hazırlığınızı nasıl organize edebilirsiniz?
          </h2>
          <p className="mt-3 text-base text-navy/60" data-id="element-252" data-mp="pliq8mn3je8i">3 basit adımda</p>
        </div>

        <ol className="relative mt-12 grid gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-253" data-mp="bpnc0u3n6rbg">
          <span aria-hidden="true" className="absolute bottom-6 left-[21px] top-6 w-px bg-electric/30 lg:bottom-auto lg:left-[22px] lg:right-[22px] lg:top-[21px] lg:h-px lg:w-auto" data-id="element-254" data-mp="fqh31wcdsm8k" />
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-5 lg:flex-col lg:gap-5" data-id="element-255" data-mp="2a25kc56350w4" data-mpi={i}>
              <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-electric font-display text-xl font-extrabold text-white" data-id="element-256" data-mp="202zsxfas3g15">
                {s.n}
              </span>
              <div data-id="element-257" data-mp="12deop4x73sl1">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-navy" data-id="element-258" data-mp="12dwuot9ntl65">{s.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy/70" data-id="element-259" data-mp="1hbp2ez8yt59s">{s.body}</p>
                {s.tags.length > 0 && <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-260" data-mp="1carl0ovs4f9c">
                    {s.tags.map(t => <li key={t} className="rounded-md border border-navy/10 bg-white px-2.5 py-1 text-xs font-medium text-navy/75" data-id="element-261" data-mp="2sorlc0yje6x4">
                        {t}
                      </li>)}
                  </ul>}
                {s.after && <p className="mt-3 text-[15px] leading-relaxed text-navy/70" data-id="element-262" data-mp="2utefginmqz9y">{s.after}</p>}
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}